module.exports = __webpack_public_path__ + "static/img/la_comp.4660db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/la_comp.png
// module id = LTJE
// module chunks = 12